import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8c6760ce"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "page d-flex flex-column"
}
const _hoisted_2 = {
  class: "flex-grow-1 view-wrapper",
  style: {"flex-basis":"0"}
}

import { settingStore } from '@/stores';
  import { onMounted, ref, computed } from 'vue';
  import { useRoute } from 'vue-router';

  
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

  const inited = ref(false);
  const route = useRoute();

  const shouldShowFooter = computed(() => {
    // Check if route meta explicitly hides footer
    if (route.meta?.hideFooter) {
      return false;
    }

    const routesWithoutFooter = [
      '/programs/onethepl6'
    ];

    // Check if current path starts with any of the routes without footer
    const shouldHideFooter = routesWithoutFooter.some(routePath =>
      route.path.startsWith(routePath)
    );

    return !shouldHideFooter;
  });

  onMounted(async () => {
    try {
      await settingStore.tryFetchData();
    } finally {
      inited.value = true;
    }
  });


return (_ctx: any,_cache: any) => {
  const _component_AppMeta = _resolveComponent("AppMeta")!
  const _component_AppHeader = _resolveComponent("AppHeader")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_AppFooter = _resolveComponent("AppFooter")!
  const _component_AppFloat = _resolveComponent("AppFloat")!
  const _component_AppUserSurvey = _resolveComponent("AppUserSurvey")!

  return (inited.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_AppMeta, _normalizeProps(_guardReactiveProps(_unref(settingStore).data.seo_meta)), null, 16),
        _createVNode(_component_AppHeader),
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_router_view)
        ]),
        (_unref(shouldShowFooter))
          ? (_openBlock(), _createBlock(_component_AppFooter, { key: 0 }))
          : _createCommentVNode("", true),
        _createVNode(_component_AppFloat),
        _createVNode(_component_AppUserSurvey)
      ]))
    : _createCommentVNode("", true)
}
}

})